import {OwcListItem, OwcIconButton, OwcIcon, OwcTypography} from '@one/react';
import React from 'react';
import '../../styles.scss';
import DelayedTooltip from "../general/DelayedTooltip.js";

/**
 * Renders a list item control for data uses
 *
 * @copyright Roche 2025
 * @author Geoffroy Maillol
 */
class DataUseListItem extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
    super(props);
    this.state = {isLoading:true};
  }

  /**
   * Runs once after construction after everything is initialised
   */
  componentDidMount() {
  }

  truncate( str, n, useWordBoundary ){
    if (str.length <= n) { return str; }
    const subString = str.slice(0, n-1); // the original check
    return (useWordBoundary
      ? subString.slice(0, subString.lastIndexOf(" "))
      : subString) + "…";
  };


  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    const dataUse = this.props.dataUse;
    let warningText = "";
    if (dataUse.versionNo === null) {
      warningText = "This data use is not published";
    }

    let approvedIconName = "circle_help";
    let approvedIconColour = "var(--one-color-orange-600)";
    let dataAccessWarningText = "";
    if (dataUse.dataAccessApproved !== null) {
      if (dataUse.dataAccessApproved === true) {
        approvedIconName = "circle_confirm";
        approvedIconColour = "var(--one-color-green-500)";
      } else {
        approvedIconName = "circle_clear";
        approvedIconColour = "var(--one-color-red-500)";
        dataAccessWarningText = "Data access denied";
      }
    } else {
      dataAccessWarningText = "Data access decision is not recorded";
    }

    if (dataAccessWarningText) {
      if (warningText) {
        warningText += `, ${dataAccessWarningText}`;
      } else {
        warningText = dataAccessWarningText;
      }
    }

    const itemId = this.props.keyPrefix + dataUse.useCaseId;
    const truncatedDataUseTitle = this.truncate(dataUse.name, 50, false);

    return (
      <div>
        <OwcListItem value={dataUse.useCaseId} key = {itemId}>
          <OwcTypography
              id={"title" + itemId}
              style={warningText===""?{}:{color:"orange"}}>
            {truncatedDataUseTitle}
          </OwcTypography>
          <span slot="secondary" id={"subtitle" + itemId} style={warningText===""?{}:{color:"orange"}}>
              Data use ID: {dataUse.useCaseId}
          </span> 
          <div style={{ display: "flex"}}  slot="prefix">
            <OwcIcon key={"iconApprovedStatus" + itemId} 
              id={"iconApprovedStatus" + itemId} 
              name={approvedIconName} family="filled"
              style={{fontSize:"1.5em", color: approvedIconColour}} />
            {dataUse.versionNo !== null
              ? <OwcIcon 
                  id={"iconPublishedStatus" + itemId} 
                  name="certificate" variant="success"
                  style={{fontSize:"1.5em", color: "var(--one-color-green-500)"}} />
              : <div key={"iconPublishedStatusSpacer" + itemId} style={{height:"0.95em", width:"1.5em"}} />
            }
          </div>
          {this.props.showActionIcon === true
            ? <OwcIconButton id={"DataUseRemovBtn" + itemId}
                slot="suffix"
                icon={this.props.actionIcon} 
                onclick={() => this.props.onAction(dataUse)}>
              </OwcIconButton>
            : <></>
          }
        </OwcListItem>     
          {truncatedDataUseTitle===dataUse.name
            ? ""
            : <DelayedTooltip key={"titleTooltip" + itemId} anchor={"title" + itemId} placement="top">{dataUse.name}</DelayedTooltip> 
          }
          {warningText===""
            ? ""
            : <>
                <DelayedTooltip key={"warningtitleTooltip" + itemId} anchor={"title" + itemId}>{warningText}</DelayedTooltip> 
                <DelayedTooltip key={"warningtitleTooltip2" + itemId} anchor={"subtitle" + itemId}>{warningText}</DelayedTooltip> 
              </>
          }
        {dataUse.versionNo !== null
          ? <DelayedTooltip key={"iconPublishedStatusTooltip" + itemId} anchor={"iconPublishedStatus" + itemId}>
              Data Use version {dataUse.versionNo} has been published
            </DelayedTooltip> 
        : ""
        }        

        {this.props.showActionIcon === true
          ? <DelayedTooltip anchor={"DataUseRemovBtn" + itemId} placement="bottom">
              {this.props.actionTooltip}
            </DelayedTooltip>
          : ""
        }
      </div>
    );
  }

}

DataUseListItem.defaultProps = {
  dataUse: {useCaseId:null, name:"", versionNo:null},
  showActionIcon: true,
  actionIcon: "circle_clear",
  actionTooltip: "Remove this data use from the selection",
  keyPrefix: "DataUseListItem",
  onAction: ()=>{},
}

export default DataUseListItem;
